import { useCallback, useEffect, useRef, useState } from 'react';
import Cookies from 'universal-cookie';
import { configSelectors } from '../../store';
import { storage } from '../utils/storage';
import { useAppSelector } from './store';

const cookies = new Cookies();

const CLICKED_TO_LEFT_REVIEW_LINK = 'CLICKED_TO_LEFT_REVIEW_LINK';
const CLOSE_REVIEW_MODAL = 'CLOSE_REVIEW_MODAL';
const DONT_SHOW_AGAIN_CLICK = 'DONT_SHOW_AGAIN_CLICK';

const MODAL_OPEN_DELAY = 2000;
const MIN_LEADS_COUNT = 10;

type UseLeftReview = (params: { todayLeadsAmount: number }) => {
  showModal: boolean;
  onClose: () => void;
  onLeftReviewClick: () => void;
  onDontShowAgainClick: () => void;
};

export const useLeftReview: UseLeftReview = ({ todayLeadsAmount }) => {
  const [showModal, setShowModal] = useState(false);
  const timerId = useRef<ReturnType<typeof setTimeout>>();
  const isWix = useAppSelector(configSelectors.isWix);

  useEffect(() => {
    const clickedToLeftReviewLink = cookies.get(CLICKED_TO_LEFT_REVIEW_LINK);
    const closeReviewModal = cookies.get(CLOSE_REVIEW_MODAL);
    const dontShowAgain = storage.getItem(DONT_SHOW_AGAIN_CLICK);

    if (dontShowAgain || closeReviewModal || clickedToLeftReviewLink || todayLeadsAmount < MIN_LEADS_COUNT || !isWix) {
      return;
    }

    timerId.current = setTimeout(() => {
      setShowModal(true);
    }, MODAL_OPEN_DELAY);

    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
  }, [todayLeadsAmount, isWix]);

  const onLeftReviewClick = useCallback(() => {
    cookies.set(CLICKED_TO_LEFT_REVIEW_LINK, 1, { maxAge: 365 * 24 * 60 * 60 });

    setShowModal(false);
  }, []);

  const onClose = useCallback(() => {
    cookies.set(CLOSE_REVIEW_MODAL, 1, { maxAge: 7 * 24 * 60 * 60 });

    setShowModal(false);
  }, []);

  const onDontShowAgainClick = useCallback(() => {
    storage.setItem(DONT_SHOW_AGAIN_CLICK, '1');

    setShowModal(false);
  }, []);

  return { showModal, onClose, onLeftReviewClick, onDontShowAgainClick };
};
